<template>
  <div
    class="el-picker-panel el-date-picker mete-date-picker"
    x-placement="bottom-start"
  >
    <div class="el-picker-panel__body-wrapper">
      <div class="el-picker-panel__body">
        <div class="el-date-picker__header">
          <button
            type="button"
            aria-label="前一年"
            class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
            @click="preYear"
          ></button
          ><button
            type="button"
            aria-label="上个月"
            class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left"
            @click="preMonth"
          ></button>

          <span role="button" class="el-date-picker__header-label">
            {{ year }} 年
          </span>
          <span role="button" class="el-date-picker__header-label">
            {{ month + 1 }} 月
          </span>

          <button
            type="button"
            aria-label="后一年"
            class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
            :class="{ 'is-disabled': isCurrent }"
            @click="nextYear"
          ></button>
          <button
            type="button"
            aria-label="下个月"
            class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right"
            :class="{ 'is-disabled': isCurrent }"
            @click="nextMonth"
          ></button>
        </div>
        <div class="el-picker-panel__content">
          <table cellspacing="0" cellpadding="0" class="el-date-table">
            <tbody>
              <tr>
                <!---->
                <th>日</th>
                <th>一</th>
                <th>二</th>
                <th>三</th>
                <th>四</th>
                <th>五</th>
                <th>六</th>
              </tr>

              <tr
                class="el-date-table__row"
                v-for="(week, index) in dayList"
                :key="index"
              >
                <td
                  v-for="(d, dIndex) in week"
                  :key="dIndex"
                  :class="d.classes"
                  @click="setDay(d.value, d.disabled)"
                >
                  <!-- <el-badge :value="12" class="item">
                    <span>{{ d.value }}</span>
                  </el-badge> -->
                  <div>
                    <span>
                      {{ d.value }}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, getDaysOfMonth } from '@/utlis/date'

const now = new Date()

const DAY_ROWS = 6
const TODAY = {
  year: now.getFullYear(),
  month: now.getMonth(),
  day: now.getDate()
}

export default {
  props: {
    date: {
      type: String,
      default: formatDate(undefined, 'YYYY-MM-DD')
    },
    dateCount: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      year: TODAY.year,
      month: TODAY.month,
      day: TODAY.day
    }
  },
  computed: {
    isCurrent() {
      return this.year === TODAY.year && this.month === TODAY.month
    },
    selected() {
      const date = new Date(this.date)
      return {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate()
      }
    },
    dayList() {
      const { year, month } = this
      const monthStr = month >= 9 ? month + 1 : `0${month + 1}`
      const first = new Date(`${year}-${monthStr}-01`)

      //
      let offset = first.getDay()
      offset = offset === 0 ? 7 : offset

      // 显示的上个月天数
      const prev = month === 0 ? 12 : month - 1
      const prevMonthDays = getDaysOfMonth(year, prev)

      // 当前月份的天数
      const monthDays = getDaysOfMonth(year, month)

      // 日期列表
      let dayList = []
      for (let row = 0; row < DAY_ROWS; row++) {
        let week = []

        for (let i = 0; i < 7; i++) {
          const index = row * 7 + i
          const monthIndex = index + 1 - offset // 当前月份第几天: 1...
          const dayStr = monthIndex > 9 ? monthIndex : `0${monthIndex}`

          if (index < offset) {
            // 上一月
            week.push({
              value: prevMonthDays + monthIndex,
              classes: 'prev-month',
              disabled: true
            })
          } else if (monthIndex > monthDays) {
            // 下一月
            week.push({
              value: monthIndex - monthDays,
              classes: 'next-month',
              disabled: true
            })
          } else {
            // 当前月
            const { year: y, month: m, day: d } = TODAY
            const isCurrentMonth = y === year && m === month
            const isSelected =
              year === this.selected.year &&
              month === this.selected.month &&
              monthIndex === this.selected.day
            const isAfter = isCurrentMonth && monthIndex > d
            const dateStr = `${year}-${monthStr}-${dayStr}`
            const hasCount = this.dateCount.find(o => o.date === dateStr)
            const disabl = (isAfter && monthIndex !== d + 1) || !hasCount
            week.push({
              value: monthIndex,
              disabled: disabl,
              classes: {
                available: true,
                today: isCurrentMonth && d === monthIndex,
                current: isSelected,
                'is-disabled': disabl
              }
            })
          }
        }

        dayList.push(week)
      }
      return dayList
    },
    nowMonth() {
      const month = this.getStr(this.month + 1)
      return `${this.year}-${month}`
    }
  },
  mounted() {
    if (this.date) {
      const date = new Date(this.date)
      this.year = date.getFullYear()
      this.month = date.getMonth()
      this.day = date.getDate()
    }
  },
  methods: {
    preYear() {
      this.year -= 1
    },
    nextYear() {
      if (!this.isCurrent) {
        this.year += 1
      }
    },
    preMonth() {
      if (this.month === 0) {
        this.year -= 1
        this.month = 11
      } else {
        this.month -= 1
      }
    },
    nextMonth() {
      if (!this.isCurrent) {
        if (this.month === 11) {
          this.year += 1
          this.month = 0
        } else {
          this.month += 1
        }
      }
    },
    setDay(day, disabled) {
      if (disabled) return
      const month = this.getStr(this.month + 1)
      const date = this.getStr(day)
      this.$emit('change', `${this.year}-${month}-${date}`)
    },
    getStr(v) {
      return v > 9 ? `${v}` : `0${v}`
    }
  },
  watch: {
    date(v, oldv) {
      if (v && (!oldv || oldv !== v)) {
        const date = new Date(v)
        this.year = date.getFullYear()
        this.month = date.getMonth()
        this.day = date.getDate()
        this.$emit('pre-change', this.nowMonth)
      }
    },
    nowMonth(month) {
      this.$emit('pre-change', month)
    }
  }
}
</script>

<style lang="scss">
.mete-date-picker.el-picker-panel {
  margin: 0;
  border-radius: 0;
  border: none;
  .el-date-picker__header {
    margin: 0;
    padding: 12px;
  }
  .el-picker-panel__content {
    margin-top: 0;
  }
  .is-disabled {
    color: #c0c4cc;
    &:hover {
      color: #c0c4cc;
    }
  }
}
</style>
